/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModGossip: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M7.32759 14.9934C8.22401 15.6275 9.31849 16 10.5 16C11.4776 16 12.3956 15.745 13.1911 15.2978L16 16L15.2978 13.1911C15.745 12.3956 16 11.4776 16 10.5C16 9.31849 15.6275 8.22401 14.9934 7.32759C14.826 11.4853 11.4853 14.826 7.32759 14.9934Z' />
			<path d='M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 8.14595 0.275364 9.22758 0.763532 10.1823L0 14L3.81766 13.2365C4.77242 13.7246 5.85405 14 7 14Z' />
		</Svg>
	);
};

export { ModGossip };
